export interface BipCheckerSummary {
  total: number;
  passed: number;
  failed: number;
  skipped: number;
}

export interface BipCheckerDetail {
  field: string;
  label: string;
  description: string;
  status: 'pass' | 'fail' | 'warning';
  rules: string;
  errors: string[];
  value_summary: string;
  metadata: {
    source: string;
    condition: string | null;
    condition_met: boolean;
  };
}

export interface BipCheckerReport {
  summary: BipCheckerSummary;
  details: {
    failed: BipCheckerDetail[];
    passed: BipCheckerDetail[];
    warnings?: BipCheckerDetail[];
  };
  timestamp: string;
}
